import { render, staticRenderFns } from "./Userprofile.vue?vue&type=template&id=31c27fd4&scoped=true&"
import script from "./Userprofile.vue?vue&type=script&lang=js&"
export * from "./Userprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c27fd4",
  null
  
)

export default component.exports